/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UserAccessIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UserAccessIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5C11 6.65685 9.65685 8 8 8C6.34315 8 5 6.65685 5 5ZM8 3C6.89543 3 6 3.89543 6 5C6 6.10457 6.89543 7 8 7C9.10457 7 10 6.10457 10 5C10 3.89543 9.10457 3 8 3Z"
                fill="currentColor"
              />
              <path
                d="M4.5 10C3.67157 10 3 10.6716 3 11.5V13H2V11.5C2 10.1193 3.11929 9 4.5 9H8V10H4.5Z"
                fill="currentColor"
              />
              <path
                d="M13.5 10C13.5 10.2761 13.2761 10.5 13 10.5C12.7239 10.5 12.5 10.2761 12.5 10C12.5 9.72386 12.7239 9.5 13 9.5C13.2761 9.5 13.5 9.72386 13.5 10Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 16H7V13.5859L10.0481 10.5368C10.0165 10.3623 10 10.1828 10 10C10 8.34315 11.3431 7 13 7C14.6569 7 16 8.34315 16 10C16 11.6569 14.6569 13 13 13V14H12V15H11V16ZM12 13V12H13C14.1046 12 15 11.1046 15 10C15 8.89543 14.1046 8 13 8C11.8954 8 11 8.89543 11 10C11 10.2932 11.0631 10.5716 11.1764 10.8225L8 14V15H10V14H11V13H12Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UserAccessIcon.tags = [
  'person',
  'access',
  'key',
  'login',
  'security',
  'authentication',
];

UserAccessIcon.category = 'General Icons';

UserAccessIcon.iconSize = 16;
